import React from "react";
import "./emptyUser.scss";

import addFile from "assets/images/manageUsers/emptyUser.svg";

import Button from "components/Button/index";

const EmptyUser = ({ handleCreateUser }) => {
  return (
    <section className="addFile">
      <div className="addFileWrapper addEmptyUser" style={{ width: "93%" }}>
        <div className="addFileContainer">
          <div className="addFileContent">
            <div className="imageWrapper">
              <img src={addFile} alt="Add File" />
            </div>
            <div className="descriptionContent">
              <h3 className="titleUser">Add User</h3>
              <p className="content">Use the add button to add a new User</p>
            </div>
            <div className="addButton">
              <Button
                onClick={handleCreateUser}
                title="Add User"
                showImage={true}
                type="violet"
                btnType="button"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmptyUser;
